import { API_URL } from '../../config';

export function checkStatusOfUser(email){
  return fetch(`${API_URL}/pub/v1/user/state?email=${encodeURIComponent(email)}`,{
    method:'GET',
    headers:{
      'Accept':'application/json',
      'Content-Type':'application/json'
    }
  })
  .then((res) => {
    if(res.status === 404){
      return Promise.resolve({ 
        data:{
          active:false,
          emailVerified:false        
        }
      });
    } else {
      return res.json();
    }
  })
  .then((res) => res.data);
}

export function checkUniquenessOfAgencyName(name){
  return fetch(`${API_URL}/pub/v1/agency/findByName?name=${name}`,{
    method:'GET',
    headers:{
      'Accept':'application/json',
      'Content-Type':'application/json'
    }
  })
  .then((res) => {
    if(res.status === 404){
      return Promise.resolve({ 
        data:{
          active:false,
          emailVerified:false        
        }
      });
    } else {
      return res.json();
    }
  })
  .then((res) => res.data);
}


export function finalizeUser(userId,password,firstName,lastName,role,token,agencyName,websiteUrl){
  const body = {
    firstName:firstName,
    lastName:lastName,
    password:password,
    role:role,
    token:token,
    agencyName:agencyName,
    websiteUrl:websiteUrl
  };

  if(!agencyName) delete body.agencyName;
  if(!websiteUrl) delete body.websiteUrl;

  return fetch(`${API_URL}/pub/v1/user/${userId}/finalize`,{
    method:'POST',
    headers:{
      'Accept':'application/json',
      'Content-Type':'application/json'
    },
    body:JSON.stringify(body)
  })
  .then((res) => {
    return res.json();
  });
}


// WEBPACK FOOTER //
// ./src/routes/OnboardingSignup/utils.js